import { render, staticRenderFns } from "./CreatedRule.vue?vue&type=template&id=16ba131c&scoped=true"
import script from "./CreatedRule.vue?vue&type=script&lang=js"
export * from "./CreatedRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ba131c",
  null
  
)

export default component.exports